import React, { useEffect, useState } from 'react';
import './EmployeeDatabase.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table, Tag } from 'antd';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const EmployeeDatabase = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { user } = useAuth();
  const username = user.user;
  const [users, setUsers] = useState([]);

  useEffect(() => {
    let endpoint = API_URL + `/users/?filter=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/users';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue) => {
    let endpoint;

    if (filterValue && (username.role === 'Admin' || username.role === 'HR')) {
      endpoint = `${API_URL}/users/?filter=${filterValue}`;
    } else if (filterValue) {
      endpoint = `${API_URL}/users/?filter=${filterValue}`;
    }
    else if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = `${API_URL}/users`;
    } else {
      endpoint = `${API_URL}/users/?filter=${username.username}`;
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error(error));
  };

  const deleteUser = async (username) => {
    try {
      const response = await axios.delete(API_URL + `/users/${username}`);

      if (response.status === 204) {
        console.log('User deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting User');
      }
    } catch (error) {
      console.error(error);
    }
  };

  //============= Add User =================================================================
  const [formData, setFormData] = useState({

    username: '',
    mobile: '',
    email: '',
    role: '',
    address: '',
    date_of_birth: '',
    blood_group: '',
    id_proof: '',
    id_proof_number: '',
    work_type: '',
    previous_work: '',
    previous_work_with: '',
    reference_name: '',
    password: '',
    confirm_password: '',
    total_task_count: '',
    total_distance_count: '',
    total_present_days_count: '',
    total_absent_days_count: '',
    uuId: '',
    manager: '',
    punch_In: '',
    punch_out: '',
    total_hour: '',
    profile: '',
    date_of_join: '',
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  let work_type_data;
  let role_data;
  let manager_data;
  if(users && users.length > 0) {
    work_type_data = users.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
    role_data = users.map(user => user.role).filter((value, index, self) => self.indexOf(value) === index);
    manager_data = users.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }
  

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(API_URL + '/registerUser', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form data sent successfully:', data);
        closeForm();
        fetchTasks();
      })
      .catch((error) => {
        console.error('Error sending form data:', error);
      });
  };

  //========================================================================================
  const getUserDetails = (username) => {
    const filteredUser = users.filter(user => user.username === username);
    navigate('/UserDetails', { state: { userDetails: filteredUser[0] } });
  };

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

  const columns = [
    {
      title: 'Index',
      dataIndex: 'Index',
      key: 'Index',
      width: '8%',
    },
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Role',
      key: 'Role',
      dataIndex: 'Role',
      width: '14%',
      render: (_, { Role }) => (
        <>
          {Role.map((tag) => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'Admin') {
              color = '#173452';
            }
            else if (tag === 'HR') {
              color = '#173452';
            }
            else if (tag === 'Manager') {
              color = '#b5cce8';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Manager',
      key: 'Manager',
      dataIndex: 'Manager',
    },
    {
      title: 'Phone No.',
      key: 'PhoneNo',
      dataIndex: 'PhoneNo',
      width: '15%',
    },
    {
      title: 'Email ID',
      dataIndex: 'EmailID',
      key: 'EmailID',
    },
    {
      title: 'Action',
      key: 'action',
      width: '10%',
      render: (_, record) => (
        <Space size="middle">
          <div onClick={() => getUserDetails(record.Name)}>
            <img className='search' src="../assets/pencil.png" alt="search" height={"24px"}></img>
          </div>
          <div onClick={() => deleteUser(record.Name)}>
            <img className='search' src="../assets/trash.png" alt="search" height={"23px"}></img>
          </div>
        </Space>
      ),
    },
  ];

  const dataa = (users && users.length > 0) ? users.map((item, index) => ({
    key: index.toString(),
    Index: index + 1,
    Name: item.username || '',
    Role: [item.role || ''],
    Manager: item.manager || '',
    PhoneNo: item.mobile || '',
    EmailID: item.email

  })) : [];

  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div class="content">
        <NewHeader></NewHeader>

        <div className='row2'>
          <h3 className='directory_Directory'>Directory</h3>
        </div>

        <div className='row3'>
          <div className='White_strip'>
            <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
            <input className='search_input' placeholder='Search' onChange={(e) => {
              const text = e.target.value;
              fetchTasks(text);
            }}></input>
          </div>
          <button className='add_user_btn_EmployeeDatabase' onClick={openForm}> + Add User </button>
        </div>
        {isFormOpen && (
          <>
            <div className="overlay_EmployeeDatabase" onClick={closeForm}></div>
            <div className="popup-form_EmployeeDatabase">
              <span className="close_EmployeeDatabase" onClick={closeForm}>&times;</span>
              <p className='addUsery_popup_EmployeeDatabase'><b>Add User</b></p>
              {/* Your form content goes here */}
              <form>
                {/* Form fields go here */}

                <div class="popup_row_EmployeeDatabase">
                  <div class="popup_column1_EmployeeDatabase">
                    <h4>Personal Info</h4>
                    <p>Full Name</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter Full Name' name='username'
                      value={formData.username}
                      onChange={handleInputChange}></input>

                    <p>Phone No.</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter Phone No.' name='mobile'
                      value={formData.mobile}
                      onChange={handleInputChange}></input>

                    <p>Email ID</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter Email ID' name='email'
                      value={formData.email}
                      onChange={handleInputChange}></input>

                    <p>Blood Group</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter Blood Group' name='blood_group'
                      value={formData.blood_group}
                      onChange={handleInputChange}></input>

                    <p>Current Address</p>
                    <textarea className='address_input_EmployeeDatabase' placeholder='Enter Current Address' name='address'
                      value={formData.address}
                      onChange={handleInputChange}></textarea>

                    <p>Permanent Address</p>
                    <textarea className='address_input_EmployeeDatabase' placeholder='Enter Permanent Address'></textarea>

                    <p>Identity Proof</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter Identity Type' name='id_proof_number'
                      value={formData.id_proof_number}
                      onChange={handleInputChange}></input><br /><br />
                    <a className='a_of_uploadHere_EmployeeDatabase' href='/'><img src='../assets/cloud_upload.png' alt='cloud_upload-icon' height={25} />&nbsp;<span className='uploadHere_EmployeeDatabase'><i>Upload Here(.jpg / .png)</i></span></a><br />
                    <br />
                  </div>

                  <div class="popup_column2_EmployeeDatabase">
                    <h4>Work Info</h4>

                    <p>Work Type</p>
                    <select className='popup_form_select' name='work_type'
                      value={formData.work_type}
                      onChange={handleInputChange}>
                      <option value="" disabled hidden>Select</option>
                      {work_type_data.map((workType, index) => (
                        <option key={index} value={workType} className='options'>
                          {workType}
                        </option>
                      ))}
                    </select>

                    <p>Role</p>
                    <select className='popup_form_select' name='role'
                      value={formData.role}
                      onChange={handleInputChange}>
                      <option value="" disabled hidden>Select</option>
                      {role_data.map((role, index) => (
                        <option key={index} value={role} className='options'>
                          {role}
                        </option>
                      ))}
                    </select>

                    <p>Manager</p>
                    <select className='popup_form_select' name='manager'
                      value={formData.manager}
                      onChange={handleInputChange}>
                      <option value="none" selected disabled hidden>Select</option>
                      {manager_data.map((manager, index) => (
                        <option key={index} value={manager} className='options'>
                          {manager}
                        </option>
                      ))}
                    </select>

                    <p>Referral Name</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter User ID' name='reference_name'
                      value={formData.reference_name}
                      onChange={handleInputChange}></input>

                    <p>Date of Joining</p>
                    <input type="date" id="date" className='popup_form_joiningDate' name='date_of_join'
                      value={formData.date_of_join}
                      onChange={handleInputChange} />

                    <p>User ID</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter User ID' name='uuId'
                      value={formData.uuId}
                      onChange={handleInputChange}></input>

                    <p>Password</p>
                    <input className='popup_input_EmployeeDatabase' placeholder='Enter Password' name='password'
                      value={formData.password}
                      onChange={handleInputChange}></input><br /><br />
                    <input className='popup_input_EmployeeDatabase' placeholder='Confirm Password' name='confirm_password'
                      value={formData.confirm_password}
                      onChange={handleInputChange}></input>


                  </div>
                </div>
                <button type="submit" value="Submit" className='popup_form_addUser_EmployeeDatabase' onClick={handleSubmit}>Add User</button>
                <button type="submit" value="close" onClick={closeForm} className='popup_form_cancel_EmployeeDatabase'>Cancel</button>
              </form>
            </div>
          </>
        )}

        <div className='row4_Directory'>
          <p>Employee Database</p>
        </div>

        <div className='table_EmployeeDatabase'>
          <Table
            columns={columns}
            dataSource={dataa}
            scroll={{ y: 420 }}
            pagination={false}
          />
        </div>



      </div>
    </div>
  )
}

export default EmployeeDatabase;